import { BundleOfferSuggestionService } from "../bundle-offer-suggestion/bundle-offer-suggestion.service";
import { Injectable, Optional } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Store } from "@ngrx/store";
import * as fromApp from "../../store/app.reducer";
import * as _ from "lodash";
import * as selectors from "../../store/app.selectors";
import * as DisableFinalPriceActions from "../../store/disable-final-price/disable-final-price.actions";
import * as checkboxPromotionsActions from "../../cart/cart-components/checkbox-promotions/store/checkbox-promotions.actions";
import * as CartPricesActions from "../../cart/cart-components/cart-prices/store/cart-prices.actions";
import { getPartialPaymentPrices } from "../../cart/cart-components/cart-prices/partial-payment-prices";
import * as CartActions from "../../cart/store/cart.actions";
import * as CartActiveCouponsActions from "../../cart/cart-components/cart-active-coupons/store/cartActiveCoupons.actions";
import * as CartCustomOptionsSelectionsActions from "../../cart/cart-components/cart-custom-options/store/cart-custom-options-selections/cart-custom-options-selections.actions";
import * as CartCustomerOptionsActions from "../../cart/cart-components/cart-custom-options/store/cart-customer-options/cart-customer-options.actions";
import {
  auditTime,
  catchError,
  distinctUntilChanged,
  first,
  retry,
  timeout,
  map,
} from "rxjs/operators";

import { ProductDetailsComponent } from "src/app/product-details/product-details.component";
import {
  AlertController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import * as ManuallyTriggerFinalPriceCheckAddressActions from "../../store/manuallyTriggerFinalPriceCheckAddress/manuallyTriggerFinalPrice.actions";
import * as DeliveryMethodAddressActions from "../../store/deliveryMethodAddress/deliveryMethodAddress.actions";
import { AnalyticsServiceService } from "../analitycsService/analytics-service.service";
import { TranslateService } from "@ngx-translate/core";
import * as groupAppActions from "../../store/group-app/groupApp.actions";
import * as storesActions from "../../store/stores/stores.actions";
import { getDistance } from "geolib";
import * as RecommendedProductsActions from "../../store/recommended-products/recommended-products.actions";
import { RecommendedProductsServiceService } from "../recommended-products/recommended-products-service.service";
import { Capacitor } from "@capacitor/core";
import { Router } from "@angular/router";
import { ReservationSystemModalsService } from "src/app/reservation-system/reservation-system-modals.service";
import * as customerPromotionsActions from "../../store/customerPromotions/customerPromotions.actions";
import * as OrderCouponRulesActions from "../../store/order-coupon-rules/orderCouponRules.actions";
import { ProductDetailsOperationsService } from "src/app/product-details/product-details-operations.service";
import * as AuthActions from "../../auth/store/auth.actions";
import {
  mergeCheckboxPromotionsWithLocalState,
  normalizeCheckboxPromotions,
} from "../../cart/cart-components/checkbox-promotions/checkbox-promotions.helpers";
import { VisitorSessionAssistService } from "../visitor-session-assist/visitor-session-assist.service";
import {
  buildPreorderRequestData,
  isVisitorInvalidatingCommentId,
  isVisitorOrderTypeConsistent,
} from "../preorder-validation-service/preorder-delivery-visitor.helpers";
import {
  buildCouponMinOrderErrorMessage,
  hasCouponMinOrderRules,
} from "../../cart/cart-components/cart-active-coupons/coupon-min-order.helpers";

@Injectable({
  providedIn: "root",
})
export class CalculateFinalPriceService {
  private developerMode: boolean;
  private stagePath: string;
  private disableFinalPrice: boolean;
  private cartProducts: any;
  private cartCustomerOptions: any = [];
  private orderPickup: boolean;
  private selectedPaymentMethodID: string;
  private store_info: any;
  private selectedLanguage: string;
  private deliveryCost = "0";
  private selectedAddress: any;
  private dineIn: boolean;
  private selectedDineInTable: any;
  private checkboxPromotions: any;
  private customersPromotions: any;
  private currentStoreId: string;
  private currentUser: any;
  private mo_token: any;
  private dispathcingFromFinalPrice: boolean = false;
  private activeCoupons: any;
  private cartProductsGifts: any;
  private previousCartGifts: any;
  private previousCart: any;
  private triggerFinalPriceTimestamp: any = null;
  private manuallytriggerFinalPriceTimestamp: any = null;
  private productDetailsModal: any;
  private selectedPreorderDate: any;
  private groupApp: any;
  private validStores: any;
  private stores: any;
  private migration_customer_id: any;
  private deliveryCostReplacedWithPrdMaxDeliveryCharge = false;
  private freeDeliveryCostOverAmount = false;
  private recommended_products: any;
  private windowDimensions: any;
  private oldSentValidStores;
  private orderCouponRules;
  private toastError: any;
  // 86ca7jc4u guard so the visitor-invalid release+logout fires once, not on
  // every debounced recalc; reset when the auth user changes.
  private visitorSessionInvalidated = false;
  // 86ca7me8k safety-net: when an only_visitor's visitor_mode desynced from the
  // selected order type (via a path that did not re-claim), reconcile the session
  // at the complete-order chokepoint instead of silently skipping the final price.
  // inFlight = a reconcile+retry is running; done = one attempt made for the
  // current desync (re-armed once the session is consistent again).
  private visitorModeRecoveryInFlight = false;
  private visitorModeRecoveryDone = false;

  constructor(
    private http: HttpClient,
    private store: Store<fromApp.AppState>,
    private modalCtrl: ModalController,
    private analyticsService: AnalyticsServiceService,
    private alertController: AlertController,
    private translateService: TranslateService,
    private router: Router,
    private toastController: ToastController,
    private recommendedProductsService: RecommendedProductsServiceService,
    private reservationSystemModalsService: ReservationSystemModalsService,
    private productDetailsOperationsService: ProductDetailsOperationsService,
    private visitorSessionAssistService: VisitorSessionAssistService,
    @Optional() private bundleOfferSuggestionService?: BundleOfferSuggestionService
  ) {}

  calculateFinalPriceSubscriptions() {
    this.store
      .select("recommendedProducts")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (
          state &&
          state.recommended_products &&
          !_.isEqual(state.recommended_products, this.recommended_products)
        ) {
          this.recommended_products = _.cloneDeep(state.recommended_products);
        }
      });

    this.store
      .select("groupApp")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (
          state &&
          state.groupApp &&
          !_.isEqual(state.groupApp, this.groupApp)
        ) {
          this.groupApp = _.cloneDeep(state.groupApp);
        }
      });

    this.store
      .select("developerMode")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (state && !_.isEqual(this.developerMode, state.developerMode)) {
          this.developerMode = _.cloneDeep(state.developerMode);
          if (this.developerMode) {
            this.stagePath = "mov5dev";
          } else {
            this.stagePath = "mov5";
          }
        }
      });

    this.store
      .select("windowInfo")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (
          state &&
          !_.isEqual(this.windowDimensions, state.windowDimensions)
        ) {
          this.windowDimensions = _.cloneDeep(state.windowDimensions);
        }
      });

    this.store
      .select("disableFinalPrice")
      .pipe(distinctUntilChanged())

      .subscribe((state) => {
        if (
          state &&
          !_.isEqual(this.disableFinalPrice, state.disableFinalPrice)
        ) {
          this.disableFinalPrice = _.cloneDeep(state.disableFinalPrice);
        }
        if (
          state &&
          state.triggerFinalPriceTimestamp &&
          !_.isEqual(
            this.triggerFinalPriceTimestamp,
            state.triggerFinalPriceTimestamp
          )
        ) {
          this.triggerFinalPriceTimestamp = _.cloneDeep(
            state.triggerFinalPriceTimestamp
          );
          this.calculateFinalPriceDebounce();
        }
      });

    this.store
      .select("currentStore")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(250))
      .subscribe((state) => {
        if (
          state &&
          state.currentStoreId &&
          !_.isEqual(this.currentStoreId, state.currentStoreId)
        ) {
          this.currentStoreId = _.cloneDeep(state.currentStoreId);

          this.store
            .select("deliveryMethodAddress")
            .pipe(first())
            .subscribe((deliveryState) => {
              const oldDeliveryCost = _.cloneDeep(this.deliveryCost);

              this.calculateDeliveryCost(
                _.find(_.cloneDeep(deliveryState.validStores || []), {
                  store_id: this.currentStoreId,
                }),
                _.cloneDeep(deliveryState.selectedAddress),
                null,
                deliveryState.orderPickup,
                deliveryState.dineIn
              );
            })
            .unsubscribe();

          this.calculateFinalPriceDebounce();
        }
      });

    this.store
      .select("auth")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (
          state &&
          !_.isEqual(this.migration_customer_id, state.migration_customer_id)
        ) {
          this.migration_customer_id = _.cloneDeep(state.migration_customer_id);

          this.calculateFinalPriceDebounce();
        }
      });

    this.store
      .select("cart")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (state && !_.isEqual(this.cartProducts, state.products)) {
          this.cartProducts = _.cloneDeep(state.products);

          this.calculateFinalPriceDebounce();
        }
      });

    this.store
      .select("cartCustomerOptions")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        const cartCustomerOptions =
          state && _.isArray(state.cartCustomerOptions)
            ? state.cartCustomerOptions
            : [];

        if (!_.isEqual(this.cartCustomerOptions, cartCustomerOptions)) {
          this.cartCustomerOptions = _.cloneDeep(cartCustomerOptions);
          this.clearPartialPaymentPrices();
          this.calculateFinalPriceDebounce();
        }
      });

    this.store //this is only for complete order button
      .select("manuallyTriggerFinalPriceCheckAddress")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (
          state &&
          state.triggerFinalPriceTimestamp &&
          !_.isEqual(
            this.manuallytriggerFinalPriceTimestamp,
            state.triggerFinalPriceTimestamp
          )
        ) {
          this.manuallytriggerFinalPriceTimestamp = _.cloneDeep(
            state.triggerFinalPriceTimestamp
          );
          console.log("finalll price manuallyy trigger from complete order");
          this.finalPriceManuallyTrigger();
        }
      });

    this.store
      .select("stores")
      .pipe(distinctUntilChanged())

      .subscribe((state) => {
        if (state && state.stores && !_.isEqual(this.stores, state.stores)) {
          this.stores = _.cloneDeep(state.stores);
        }
      });

    this.store
      .select("checkboxPromotions")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (
          state &&
          state.checkboxPromotions &&
          !_.isEqual(
            this.checkboxPromotions,
            normalizeCheckboxPromotions(state.checkboxPromotions)
          )
        ) {
          this.checkboxPromotions = normalizeCheckboxPromotions(
            state.checkboxPromotions
          );
          this.calculateFinalPriceDebounce();
        }
      });

    this.store
      .select("cartActiveCoupons")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (state && !_.isEqual(this.activeCoupons, state.activeCoupons)) {
          this.activeCoupons = _.cloneDeep(state.activeCoupons);
          console.log("activeCouponsFinalPrice", this.activeCoupons);
          this.calculateFinalPriceDebounce();
        }
      });

    this.store
      .select("deliveryMethodAddress")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (state && !_.isEqual(this.orderPickup, state.orderPickup)) {
          this.orderPickup = _.cloneDeep(state.orderPickup);
          if (
            this.validStores &&
            this.validStores.length &&
            !this.orderPickup &&
            !state.dineIn
          ) {
            let currentValidStore = _.find(this.validStores, {
              store_id: this.currentStoreId,
            });
            console.log(
              "calc delivery cost",
              currentValidStore,
              state.selectedAddress
            );
            const oldDeliveryCost = _.cloneDeep(this.deliveryCost);
            this.calculateDeliveryCost(
              _.cloneDeep(currentValidStore),
              _.cloneDeep(state.selectedAddress),
              null,
              state.orderPickup,
              state.dineIn
            );
          } else {
            this.deliveryCost = "0";
          }
          this.calculateFinalPriceDebounce();
        }

        if (state && !_.isEqual(this.dineIn, state.dineIn)) {
          this.dineIn = _.cloneDeep(state.dineIn);
          if (
            this.validStores &&
            this.validStores.length &&
            !state.orderPickup &&
            !this.dineIn
          ) {
            let currentValidStore = _.find(this.validStores, {
              store_id: this.currentStoreId,
            });
            if (currentValidStore) {
              console.log(
                "calc delivery cost",
                currentValidStore,
                state.selectedAddress
              );
              const oldDeliveryCost = _.cloneDeep(this.deliveryCost);
              this.calculateDeliveryCost(
                _.cloneDeep(currentValidStore),
                _.cloneDeep(state.selectedAddress),
                null,
                state.orderPickup,
                state.dineIn
              );
            } else {
              this.deliveryCost = "0";
            }
          } else {
            this.deliveryCost = "0";
          }
          this.calculateFinalPriceDebounce();
        }
        if (
          state &&
          !_.isEqual(state.selectedPreorderDate, this.selectedPreorderDate)
        ) {
          this.selectedPreorderDate = _.cloneDeep(state.selectedPreorderDate);
          this.calculateFinalPriceDebounce();
        }

        if (
          state &&
          !_.isEqual(this.selectedDineInTable, state.selectedDineInTable)
        ) {
          this.selectedDineInTable = _.cloneDeep(state.selectedDineInTable);
          this.calculateFinalPriceDebounce();
        }

        if (state && !_.isEqual(this.validStores, state.validStores)) {
          this.validStores = _.cloneDeep(state.validStores);
          console.log(
            "valid ssstores",
            this.validStores,
            this.orderPickup,
            this.dineIn
          );
          if (
            this.validStores &&
            this.validStores.length &&
            !this.orderPickup &&
            !this.dineIn
          ) {
            let currentValidStore = _.find(this.validStores, {
              store_id: this.currentStoreId,
            });
            if (currentValidStore) {
              console.log(
                "calc delivery cost",
                currentValidStore,
                state.selectedAddress
              );
              const oldDeliveryCost = _.cloneDeep(this.deliveryCost);
              this.calculateDeliveryCost(
                _.cloneDeep(currentValidStore),
                _.cloneDeep(state.selectedAddress),
                null,
                state.orderPickup,
                state.dineIn
              );
            } else {
              this.deliveryCost = "0";
            }
          } else {
            this.deliveryCost = "0";
          }

          this.calculateFinalPriceDebounce();
        }

        if (state && !_.isEqual(this.selectedAddress, state.selectedAddress)) {
          let calcFinalPrice = false;
          if (!this.selectedAddress && state.selectedAddress) {
            calcFinalPrice = true;
          }
          if (
            (!this.selectedAddress && state.selectedAddress) ||
            (this.selectedAddress &&
              this.selectedAddress.address_id &&
              state.selectedAddress &&
              state.selectedAddress.address_id &&
              (this.selectedAddress.address_id !==
                state.selectedAddress.address_id ||
                !_.isEqual(
                  this.selectedAddress.distance_by_store_id,
                  state.selectedAddress.distance_by_store_id
                )))
          ) {
            let currentValidStore = _.find(this.validStores, {
              store_id: this.currentStoreId,
            });

            const oldDeliveryCost = _.cloneDeep(this.deliveryCost);
            this.calculateDeliveryCost(
              _.cloneDeep(currentValidStore),
              _.cloneDeep(state.selectedAddress),
              null,
              state.orderPickup,
              state.dineIn
            );

            calcFinalPrice = true;
          }
          this.selectedAddress = _.cloneDeep(state.selectedAddress);
          if (calcFinalPrice) {
            this.calculateFinalPriceDebounce();
          }
        }
      });

    this.store
      .select("selectedPaymentMethodID")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (
          state &&
          state.selectedPaymentMethodID &&
          !_.isEqual(
            this.selectedPaymentMethodID,
            state.selectedPaymentMethodID
          )
        ) {
          this.selectedPaymentMethodID = _.cloneDeep(
            state.selectedPaymentMethodID
          );
          this.calculateFinalPriceDebounce();
        }
      });

    this.store
      .select(selectors.getStoreInfo)
      .pipe(distinctUntilChanged())

      .subscribe((store_info) => {
        if (store_info && !_.isEqual(this.store_info, store_info)) {
          this.store_info = _.cloneDeep(store_info);
        }
      });

    this.store
      .select("groupApp")
      .pipe(distinctUntilChanged())

      .subscribe((state) => {
        if (
          state &&
          state.selectedLangugage &&
          !_.isEqual(state.selectedLangugage, this.selectedLanguage)
        ) {
          this.selectedLanguage = _.cloneDeep(state.selectedLangugage);
        }
      });

    this.store
      .select("auth")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (state && !_.isEqual(state.user, this.currentUser)) {
          this.currentUser = _.cloneDeep(state.user);
          this.visitorSessionInvalidated = false;
          this.visitorModeRecoveryInFlight = false;
          this.visitorModeRecoveryDone = false;
          this.calculateFinalPriceDebounce();
        }
        if (state && !_.isEqual(state.mo_token, this.mo_token)) {
          this.mo_token = _.cloneDeep(state.mo_token);
        }
      });

    this.store
      .select("orderCouponRules")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(50))
      .subscribe((state) => {
        if (
          state &&
          !_.isEqual(state.orderCouponRules, this.orderCouponRules)
        ) {
          this.orderCouponRules = _.cloneDeep(state.orderCouponRules);
        }
      });
  }

  calculateDeliveryMethod(pickup, dinein) {
    let deliveryMethod;
    if (pickup && !dinein) {
      deliveryMethod = "takeaway";
    } else if (!pickup && !dinein) {
      deliveryMethod = "delivery";
    } else if (!pickup && dinein) {
      deliveryMethod = "dinein";
    }

    return _.cloneDeep(deliveryMethod);
  }

  // A visitor session is bound to a fixed order type: takeaway visitors must
  // order pickup, dine-in visitors must order dine-in, and Delivery visitors
  // must retain an explicit Delivery selection. Right after an order the
  // delivery method is cleared
  // (orderPickup/dineIn -> null) before the visitor session is torn down, so a
  // final-price recalc could otherwise fire with a delivery method that
  // contradicts visitor_mode and the backend rejects it
  // (invalid_visitor_order_type). Guard so we never send inconsistent visitor
  // state to calculate-final-price. Non-visitor users are unconstrained.
  private isVisitorDeliveryMethodConsistent(): boolean {
    return isVisitorOrderTypeConsistent(
      this.currentUser,
      this.orderPickup,
      this.dineIn
    );
  }

  private finalPriceActions() {
    console.log(
      "all atrr from final price debounce func",
      this.stagePath,
      this.cartProducts,
      this.store_info,
      this.cartCustomerOptions,
      this.activeCoupons,
      this.currentUser
    );
    if (!this.disableFinalPrice) {
      this.store.dispatch(
        new DisableFinalPriceActions.SetDisableFinalPrice(true)
      );
      console.log(
        "all atrr from final price debounce func",
        this.stagePath,
        this.cartProducts,
        this.store_info,
        this.cartCustomerOptions,
        this.activeCoupons,
        this.currentUser
      );
      if (
        this.stagePath &&
        this.store_info &&
        this.store_info.store_id &&
        this.currentStoreId &&
        this.store_info.group &&
        this.isVisitorDeliveryMethodConsistent()
      ) {
        console.log("calling calculateFinalPrice");
        if (this.activeCoupons && this.activeCoupons.length > 0) {
          this.activeCouponsSanityCheck(this.activeCoupons);
        }
        let baseLanguage: string = "";
        const langs = _.cloneDeep(this.groupApp.languages);
        const moBaseLanguage = _.find(langs, { mo_base: true });
        if (moBaseLanguage && moBaseLanguage.code) {
          baseLanguage = moBaseLanguage.code;
        }
        console.log("delivery cost", this.deliveryCost);
        this.calculateFinalPrice(
          {
            ...this.bundleOfferSuggestionService?.requestCapability(),
            store_id: this.store_info.store_id,
            group: this.store_info.group,
            baseLanguage: baseLanguage || "el",
            selectedLanguage: this.selectedLanguage
              ? this.selectedLanguage
              : "el",
            pickup: this.orderPickup,
            dinein: this.dineIn,
            dinein_table_id: this.selectedDineInTable
              ? this.selectedDineInTable.table_id
              : null,
            deliveryCost: this.deliveryCost,
            checkboxPromotions: normalizeCheckboxPromotions(
              this.checkboxPromotions || []
            ),
            cartCustomOptions: _.isArray(this.cartCustomerOptions)
              ? this.cartCustomerOptions
              : [],
            coupons: this.currentUser ? this.activeCoupons : [],
            cart: this.cartProducts || [],
            ...buildPreorderRequestData(
              this.currentUser,
              this.selectedPreorderDate
            ),
            migration_customer_id:
              this.store_info && this.store_info.vatBasedCustomerProductsActive
                ? this.migration_customer_id
                : null,
            selectedPaymentMethodID: this.selectedPaymentMethodID,
            selectedAddress: this.selectedAddress,
            freeDeliveryCostOverAmount: this.freeDeliveryCostOverAmount,
            recommended_products: this.recommended_products || [],
            platform: Capacitor.isNativePlatform() ? "mobile" : "web",
            catalogZeroPricesMode:
              this.currentUser && !this.currentUser.skipCatalogZeroPricesMode
                ? this.currentUser.catalogZeroPricesMode
                : null,
            customer_id: this.currentUser ? this.currentUser.customer_id : null,

            orderCouponRules: this.orderCouponRules,
            onlyDineInUser: this.currentUser?.only_dinein || null,
            uposMoUser: !!this.currentUser?.uposMoUser,
          },
          this.mo_token ? this.mo_token : null
        ).subscribe({
          next: async (res: any) => {
            if (res && res.success) {
              this.checkForNotValidCouponsAndPresentAlerts(res);

              if (
                res.customerPromotions &&
                !_.isEmpty(res.customerPromotions) &&
                _.isArray(res.customerPromotions)
              ) {
                this.store.dispatch(
                  new customerPromotionsActions.SetCustomerPromotions(
                    _.cloneDeep(res.customerPromotions)
                  )
                );
              } else {
                this.store.dispatch(
                  new customerPromotionsActions.ClearCustomerPromotions()
                );
              }

              if (
                res.checkboxPromotions &&
                !_.isEmpty(res.checkboxPromotions)
              ) {
                const mergedCheckboxPromotions =
                  mergeCheckboxPromotionsWithLocalState(
                    res.checkboxPromotions,
                    this.checkboxPromotions
                  );

                this.store.dispatch(
                  new checkboxPromotionsActions.SetCheckboxPromotions(
                    _.cloneDeep(mergedCheckboxPromotions)
                  )
                );
              } else {
                this.store.dispatch(
                  new checkboxPromotionsActions.ClearCheckboxPromotions()
                );
                if (navigator.cookieEnabled) {
                  window.localStorage.removeItem("checkboxPromotions");
                }
              }

              if (res.subTotalNoPromos) {
                this.store.dispatch(
                  new checkboxPromotionsActions.SetSubtotalNoPromos(
                    _.cloneDeep(res.subTotalNoPromos)
                  )
                );
              }

              this.store.dispatch(
                new OrderCouponRulesActions.SetOrderCouponRules(
                  _.cloneDeep(res.orderCouponRules)
                )
              );

              this.store.dispatch(
                new AuthActions.SetStoreNetworkConnected(
                  _.cloneDeep(res.storeNetworkConnected) || null
                )
              );

              if (
                res.coupons &&
                !_.isEmpty(res.coupons) &&
                !this.currentUser?.only_dinein
              ) {
                this.activeCoupons = res.coupons;
                this.store.dispatch(
                  new CartActiveCouponsActions.SetActiveCoupons(
                    _.cloneDeep(res.coupons)
                  )
                );
              } else {
                this.store.dispatch(
                  new CartActiveCouponsActions.SetActiveCoupons(_.cloneDeep([]))
                );
              }
              this.cartProducts = res.cart;
              if (res.cart) {
                this.store.dispatch(
                  new CartActions.SetCartProducts(
                    _.cloneDeep(this.cartProducts)
                  )
                );
                if (navigator.cookieEnabled) {
                  window.localStorage.setItem("cart", JSON.stringify(res.cart));
                }
              }
              this.cartProductsGifts = [];
              _.each(this.cartProducts, (cartProduct) => {
                if (cartProduct.gift || cartProduct.product_coupon_timestamp) {
                  this.cartProductsGifts.push(cartProduct);
                }
              });
              console.log("cartProductsGifts", this.cartProductsGifts);
              console.log("cartProductsGiftsPrevious", this.previousCartGifts);
              if (
                (this.previousCartGifts &&
                  this.previousCartGifts.length &&
                  this.cartProductsGifts &&
                  this.cartProductsGifts.length &&
                  this.previousCartGifts.length <
                    this.cartProductsGifts.length) ||
                (this.cartProductsGifts &&
                  this.cartProductsGifts.length &&
                  (!this.previousCartGifts ||
                    (_.isArray(this.previousCartGifts) &&
                      !this.previousCartGifts.length)))
              ) {
                let giftsToShowArray: any = _.differenceBy(
                  this.cartProductsGifts,
                  this.previousCartGifts,
                  "cart_id"
                );
                if (giftsToShowArray && giftsToShowArray.length) {
                  this.calculateGiftToShow(giftsToShowArray[0]);
                }
              }

              this.previousCartGifts = [];
              _.each(this.cartProducts, (cartProduct) => {
                if (cartProduct.gift || cartProduct.product_coupon_timestamp) {
                  this.previousCartGifts.push(cartProduct);
                }
              });

              this.store
                .select("deliveryMethodAddress")
                .pipe(first())
                .subscribe((state) => {
                  let minOrder;
                  if (state.validStores && state.validStores.length > 0) {
                    let validStores = _.cloneDeep(state.validStores);
                    let currentStore = _.find(validStores, {
                      store_id: this.currentStoreId,
                    });
                    console.log(
                      "valid stores",
                      validStores,
                      this.currentStoreId
                    );
                    // console.log("current store", currentStore);
                    if (currentStore) {
                      minOrder = currentStore.minOrder;
                    }
                    // console.log("deliveryCost", deliveryCost);
                    console.log("minOrder", minOrder);
                    console.log(
                      "subtotalOfOmittedProductsFromMinOrder",
                      res.subtotalOfOmittedProductsFromMinOrder
                    );
                  }

                  let subtotalOfOmittedProductsFromMinOrder =
                    res.subtotalOfOmittedProductsFromMinOrder;
                  let amountToMinimumOrder: any;

                  //calculate delivery cost
                  let retryFinalPrice;
                  console.log(
                    "delivery cost first if",
                    state.orderPickup,
                    state.dineIn
                  );
                  if (
                    !state.orderPickup &&
                    !state.dineIn &&
                    parseFloat(subtotalOfOmittedProductsFromMinOrder) > 0
                  ) {
                    let maxDeliveryCharge = 0;

                    _.each(res.cart, (cartProduct) => {
                      if (cartProduct && cartProduct.extra_delivery_charge) {
                        if (
                          maxDeliveryCharge <
                          parseFloat(cartProduct.extra_delivery_charge)
                        ) {
                          maxDeliveryCharge = _.cloneDeep(
                            parseFloat(cartProduct.extra_delivery_charge)
                          );
                        }
                      }
                    });
                    if (
                      res.subtotal === subtotalOfOmittedProductsFromMinOrder &&
                      res.cart &&
                      res.cart.length > 0 &&
                      maxDeliveryCharge
                    ) {
                      if (
                        +parseFloat(this.deliveryCost).toFixed(2) !==
                        maxDeliveryCharge
                      ) {
                        retryFinalPrice = true;
                        console.log("retry final price");
                      }

                      if (
                        +parseFloat(this.deliveryCost).toFixed(2) !==
                        maxDeliveryCharge
                      ) {
                        this.deliveryCost = maxDeliveryCharge.toString();
                        this.deliveryCostReplacedWithPrdMaxDeliveryCharge =
                          true;
                        if (
                          this.deliveryCost &&
                          parseFloat(this.deliveryCost)
                        ) {
                          this.deliveryCost = parseFloat(
                            parseFloat(this.deliveryCost).toFixed(1)
                          ).toFixed(2);
                        }
                      }

                      console.log("deliveryCost", this.deliveryCost);
                    } else {
                      const oldDeliveryCost = _.cloneDeep(this.deliveryCost);

                      const validStore =
                        this.validStores && this.validStores.length
                          ? _.find(_.cloneDeep(this.validStores), {
                              store_id: this.currentStoreId,
                            })
                          : null;

                      this.calculateDeliveryCost(
                        validStore,
                        _.cloneDeep(this.selectedAddress),
                        res,
                        state.orderPickup,
                        state.dineIn
                      );

                      if (
                        this.oldSentValidStores &&
                        !_.isEqual(this.validStores, this.oldSentValidStores)
                      ) {
                        _.each(this.validStores, (validStore) => {
                          _.each(this.oldSentValidStores, (oldValidStore) => {
                            if (
                              validStore.store_id === oldValidStore.store_id
                            ) {
                            }
                            if (
                              !_.isEqual(
                                validStore.delivery_cost_per_kilometer_active,
                                oldValidStore.delivery_cost_per_kilometer_active
                              ) ||
                              !_.isEqual(
                                validStore.charge_after_distance,
                                oldValidStore.charge_after_distance
                              ) ||
                              !_.isEqual(
                                validStore.step_active,
                                oldValidStore.step_active
                              ) ||
                              !_.isEqual(
                                validStore.fixed_charge,
                                oldValidStore.fixed_charge
                              )
                            ) {
                              retryFinalPrice = true;
                            }
                          });
                        });
                      }

                      this.oldSentValidStores = _.cloneDeep(this.validStores);

                      if (oldDeliveryCost !== this.deliveryCost) {
                        console.log(
                          "not equal delivery cost",
                          this.deliveryCost
                        );
                        retryFinalPrice = true;
                      }

                      console.log("deliveryCost", this.deliveryCost);
                    }
                  } else {
                    const oldDeliveryCost = _.cloneDeep(this.deliveryCost);

                    const validStore =
                      this.validStores && this.validStores.length
                        ? _.find(_.cloneDeep(this.validStores), {
                            store_id: this.currentStoreId,
                          })
                        : null;
                    this.calculateDeliveryCost(
                      validStore || null,
                      _.cloneDeep(this.selectedAddress),
                      res,
                      state.orderPickup,
                      state.dineIn
                    );

                    if (
                      this.oldSentValidStores &&
                      !_.isEqual(this.validStores, this.oldSentValidStores)
                    ) {
                      _.each(this.validStores, (validStore) => {
                        _.each(this.oldSentValidStores, (oldValidStore) => {
                          if (validStore.store_id === oldValidStore.store_id) {
                          }
                          if (
                            !_.isEqual(
                              validStore.delivery_cost_per_kilometer_active,
                              oldValidStore.delivery_cost_per_kilometer_active
                            ) ||
                            !_.isEqual(
                              validStore.charge_after_distance,
                              oldValidStore.charge_after_distance
                            ) ||
                            !_.isEqual(
                              validStore.step_active,
                              oldValidStore.step_active
                            ) ||
                            !_.isEqual(
                              validStore.fixed_charge,
                              oldValidStore.fixed_charge
                            )
                          ) {
                            retryFinalPrice = true;
                          }
                        });
                      });
                    }

                    this.oldSentValidStores = _.cloneDeep(this.validStores);

                    if (oldDeliveryCost !== this.deliveryCost) {
                      console.log("not equal delivery cost", this.deliveryCost);
                      retryFinalPrice = true;
                    }
                  }

                  if (
                    parseFloat(subtotalOfOmittedProductsFromMinOrder) > 0 &&
                    res.subtotal === subtotalOfOmittedProductsFromMinOrder &&
                    this.deliveryCost &&
                    parseFloat(this.deliveryCost) > 0
                  ) {
                    console.log("Discount is null");
                    amountToMinimumOrder = null;
                  } else if (
                    !this.orderPickup &&
                    !this.dineIn &&
                    !res.ignoreMinOrder &&
                    this.store_info.minorderGrandTotal &&
                    parseFloat(res.grand_total) -
                      parseFloat(
                        this.deliveryCost ? this.deliveryCost.toString() : "0"
                      ) -
                      parseFloat(
                        res.subtotalOfOmittedCartCustomOptionsFromMinOrder
                      ) -
                      parseFloat(res.subtotalOfOmittedProductsFromMinOrder) -
                      parseFloat(minOrder) <
                      parseFloat(minOrder)
                  ) {
                    amountToMinimumOrder =
                      (parseFloat(res.grand_total) -
                        parseFloat(
                          this.deliveryCost ? this.deliveryCost.toString() : "0"
                        ) -
                        parseFloat(
                          res.subtotalOfOmittedCartCustomOptionsFromMinOrder
                        ) -
                        parseFloat(res.subtotalOfOmittedProductsFromMinOrder) -
                        parseFloat(minOrder)) *
                      -1;
                    amountToMinimumOrder = amountToMinimumOrder.toFixed(2);
                    console.log(
                      "$rootScope.amountToMinimumOrder 1",
                      amountToMinimumOrder
                    );
                    if (
                      amountToMinimumOrder === "0.00" ||
                      parseFloat(amountToMinimumOrder) <= 0
                    ) {
                      amountToMinimumOrder = null;
                    }
                  } else if (
                    !this.orderPickup &&
                    !this.dineIn &&
                    !res.ignoreMinOrder &&
                    !this.store_info.minorderGrandTotal &&
                    parseFloat(res.subtotal) +
                      parseFloat(res.cartCustomOptionsTotalPrice) -
                      parseFloat(
                        this.deliveryCost ? this.deliveryCost.toString() : "0"
                      ) -
                      parseFloat(
                        res.subtotalOfOmittedCartCustomOptionsFromMinOrder
                      ) -
                      parseFloat(res.subtotalOfOmittedProductsFromMinOrder) <
                      parseFloat(minOrder)
                  ) {
                    amountToMinimumOrder =
                      (parseFloat(res.subtotal) +
                        parseFloat(res.cartCustomOptionsTotalPrice) -
                        parseFloat(
                          res.subtotalOfOmittedCartCustomOptionsFromMinOrder
                        ) -
                        parseFloat(res.subtotalOfOmittedProductsFromMinOrder) -
                        parseFloat(minOrder)) *
                      -1;
                    console.log(
                      "$rootScope.amountToMinimumOrder 2",
                      amountToMinimumOrder
                    );
                    amountToMinimumOrder = amountToMinimumOrder.toFixed(2);
                    if (
                      amountToMinimumOrder === "0.00" ||
                      parseFloat(amountToMinimumOrder) <= 0
                    ) {
                      amountToMinimumOrder = null;
                    }
                  } else {
                    console.log("else discount is to be null");

                    amountToMinimumOrder = null;
                  }
                  // let currentOrderPoints: any;
                  // if (this.groupApp.points && this.groupApp.points.rules) {
                  //   var order_rule = _.find(this.groupApp.points.rules, {
                  //     type: "order",
                  //   });

                  //   console.log("groupAppPoints", this.groupApp.points);

                  //   if (order_rule) {
                  //     var amount_for_points = parseFloat(res.subTotalNoPromos);
                  //     console.log("amount_for_points", amount_for_points);
                  //     var points =
                  //       (amount_for_points * order_rule.points_ratio) /
                  //       order_rule.amount_ratio;
                  //     console.log("points", points);
                  //     if (points > 0) {
                  //       currentOrderPoints = points.toFixed();
                  //     } else {
                  //       currentOrderPoints = 0;
                  //     }
                  //   }
                  // } else {
                  //   currentOrderPoints = 0;
                  // }

                  const bundlePromptOwnsOverlay = !retryFinalPrice && !!this.bundleOfferSuggestionService?.handlePricingResponse(res, {
                    productDetailsOpen: !!this.productDetailsModal,
                    promotionNoticeOpening: !!res.coupon_errors?.length,
                    minimumOrder: !state.orderPickup && !state.dineIn && !res.ignoreMinOrder ? Number(minOrder) : 0,
                    minimumOrderSubtotal: (this.store_info.minorderGrandTotal ? Number(res.grand_total) : Number(res.subtotal) + Number(res.cartCustomOptionsTotalPrice)) -
                      Number(this.deliveryCost || 0) - Number(res.subtotalOfOmittedCartCustomOptionsFromMinOrder) - Number(res.subtotalOfOmittedProductsFromMinOrder),
                  });
                  const recommended_products = res.recommended_products;

                  this.calculateRecommendedAppearedProducts(
                    _.cloneDeep(res.cart),
                    recommended_products
                  );

                  this.recommended_products = _.cloneDeep(recommended_products);

                  this.store.dispatch(
                    new RecommendedProductsActions.SetRecommendedProducts(
                      _.cloneDeep(recommended_products || [])
                    )
                  );

                  if (recommended_products && recommended_products.length) {
                    const hasProductsToRecommend = !!_.find(
                      recommended_products,
                      (prd) => {
                        if (prd && !prd.recommendation_appeared) {
                          return prd;
                        }
                      }
                    );

                    if (
                      !bundlePromptOwnsOverlay && hasProductsToRecommend &&
                      !this.currentUser?.uposMoUser
                    ) {
                      this.recommendedProductsService.showRecommendedProductsModal();
                    }
                  }

                  let cartPrices = {
                    ...getPartialPaymentPrices(res),
                    subtotal: res.subtotal,
                    deliveryCost:
                      state &&
                      state.orderPickup == false &&
                      state.dineIn == false
                        ? parseFloat(this.deliveryCost)
                        : "",
                    minOrder: minOrder,
                    grand_total_without_delivery_tips:
                      res.grand_total_without_delivery_tips,
                    cartCustomOptionsTotalPriceWithoutTipsAndWrapperTax:
                      res.cartCustomOptionsTotalPriceWithoutTipsAndWrapperTax,
                    deliveryTipsTotal: res.deliveryTipsTotal,
                    waiterTipsTotal: res.waiterTipsTotal,
                    wrapperTaxTotal: res.wrapperTaxTotal,
                    cartCustomOptionsTotalPrice:
                      res.cartCustomOptionsTotalPrice,
                    grand_total: res.grand_total,
                    discount_amount: res.discount_amount,
                    subTotalNoPromos: res.subTotalNoPromos,
                    subtotalOfOmittedProductsFromMinOrder:
                      res.subtotalOfOmittedProductsFromMinOrder,
                    subtotalOfOmittedCartCustomOptionsFromMinOrder:
                      res.subtotalOfOmittedCartCustomOptionsFromMinOrder,
                    amountToMinimumOrder: amountToMinimumOrder,
                    currentOrderPoints: res.points,
                    points_deducted_from_coupon:
                      res.points_deducted_from_coupon,
                    vatLevelsTotals: res.vatLevelsTotals,
                    vat_total: res.vat_total,
                    deliveryCostReplacedWithPrdMaxDeliveryCharge:
                      this.deliveryCostReplacedWithPrdMaxDeliveryCharge,
                  };
                  this.store.dispatch(
                    new CartPricesActions.SetCartPrices(_.cloneDeep(cartPrices))
                  );
                  this.dispathcingFromFinalPrice = false;

                  if (
                    res.groupAppUpdatedAttributes &&
                    _.isObject(res.groupAppUpdatedAttributes) &&
                    !_.isEmpty(res.groupAppUpdatedAttributes)
                  ) {
                    this.updateGroupAppAttr(res.groupAppUpdatedAttributes);
                  }

                  if (
                    res.storeUpdatedAttributes &&
                    _.isObject(res.storeUpdatedAttributes) &&
                    !_.isEmpty(res.storeUpdatedAttributes)
                  ) {
                    this.updateStoreInfoAttr(res.storeUpdatedAttributes);
                  }

                  if (retryFinalPrice) {
                    retryFinalPrice = false;
                    this.store.dispatch(
                      new DisableFinalPriceActions.SetTriggerFinalPriceTimestamp(
                        Date.now()
                      )
                    );
                  }
                  this.store.dispatch(
                    new DisableFinalPriceActions.SetDisableFinalPrice(false)
                  );
                })
                .unsubscribe();

              this.analyticsService.dmAnalyticsMessage(
                "cart_calculation",
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null
              );
            } else {
              this.clearPartialPaymentPrices();
              if (await this.handleVisitorInvalidError(res)) {
                return;
              }
              const alert = await this.alertController.create({
                header: this.translateService.instant("alert"),
                message:
                  res && res.comment_id
                    ? this.translateService.instant(res.comment_id)
                    : this.translateService.instant(
                        "errorMessages.general_error"
                      ),
                backdropDismiss: false,
                buttons: ["OK"],
              });
              await alert.present();
              this.store.dispatch(
                new ManuallyTriggerFinalPriceCheckAddressActions.SetFinalPriceSuccess(
                  false
                )
              );
              this.store.dispatch(
                new DisableFinalPriceActions.SetDisableFinalPrice(false)
              );
            }
          },
          error: async (error) => {
            console.log(" catch error", error);
            this.clearPartialPaymentPrices();

            this.store.dispatch(
              new ManuallyTriggerFinalPriceCheckAddressActions.SetFinalPriceSuccess(
                false
              )
            );
            this.store.dispatch(
              new DisableFinalPriceActions.SetDisableFinalPrice(false)
            );

            if (
              error &&
              error.status !== 401 &&
              error.statusText !== "Unauthorized"
            ) {
              const alert = await this.alertController.create({
                header: this.translateService.instant("alert"),
                message: this.translateService.instant(
                  "errorMessages.problem_reaching_server"
                ),

                buttons: ["OK"],
              });
              await alert.present();
              return error;
            }
          },
        });
      } else {
        this.store.dispatch(
          new DisableFinalPriceActions.SetDisableFinalPrice(false)
        );
        // this.calculateFinalPriceDebounce();
        //called two times thats why comment out
      }
    } else {
      console.log("finalPrice is disabled");
    }
    console.log("debounced function");
  }

  // 86ca7jc4u: when a final-price response fails for an only_visitor whose
  // session is no longer valid, show one translated message, release the slot
  // and log out, returning true so the caller skips the generic (untranslated,
  // looping) alert. Returns false for all other cases (behavior unchanged).
  private async handleVisitorInvalidError(res: any): Promise<boolean> {
    if (
      !this.currentUser ||
      !this.currentUser.only_visitor ||
      !res ||
      !isVisitorInvalidatingCommentId(res.comment_id) ||
      this.visitorSessionInvalidated
    ) {
      return false;
    }
    this.visitorSessionInvalidated = true;
    const visitorUser = _.cloneDeep(this.currentUser);
    const alert = await this.alertController.create({
      header: this.translateService.instant("alert"),
      message: this.translateService.instant(
        "errorMessages.visitor_session_no_longer_valid"
      ),
      backdropDismiss: false,
      buttons: ["OK"],
    });
    await alert.present();
    this.visitorSessionAssistService.releaseVisitorSession(visitorUser);
    this.store.dispatch(
      new AuthActions.SetLogoutFlagTimestamp(Date.now().toString())
    );
    this.store.dispatch(
      new ManuallyTriggerFinalPriceCheckAddressActions.SetFinalPriceSuccess(
        false
      )
    );
    this.store.dispatch(
      new DisableFinalPriceActions.SetDisableFinalPrice(false)
    );
    return true;
  }

  private calculateFinalPriceDebounce = _.debounce(this.finalPriceActions, 600);

  // 86ca7me8k safety-net. When an only_visitor reaches complete-order with a
  // visitor_mode that no longer matches the selected order type (a path changed
  // the order type without re-claiming the session), reconcile the visitor
  // session to the current order type, then re-fire the trigger so the order can
  // proceed — instead of silently skipping the final price forever (dead button).
  private async recoverVisitorModeAndRetry(): Promise<void> {
    this.visitorModeRecoveryInFlight = true;
    this.visitorModeRecoveryDone = true; // one attempt per desync; re-armed when consistent
    try {
      const targetMode: "takeaway" | "dinein" | "delivery" =
        this.dineIn === true
          ? "dinein"
          : this.orderPickup === true
          ? "takeaway"
          : "delivery";
      const reconciled =
        await this.visitorSessionAssistService.reconcileVisitorSessionForMode(
          this.store_info,
          targetMode
        );
      if (targetMode === "dinein" && reconciled && reconciled.dineInTable) {
        this.store.dispatch(
          new DeliveryMethodAddressActions.setSelectedDineInTable(
            _.cloneDeep(reconciled.dineInTable)
          )
        );
      }
      // Refresh the local user snapshot from the now-reconciled store so the
      // re-fired trigger sees the new visitor_mode immediately (the auth
      // subscription is auditTime-debounced and may lag).
      this.currentUser = await this.getAuthUserSnapshot();
    } catch (e) {
      console.log("visitor mode recovery error", e);
    } finally {
      this.visitorModeRecoveryInFlight = false;
      this.store.dispatch(
        new DisableFinalPriceActions.SetDisableFinalPrice(false)
      );
      // Re-fire complete-order; now consistent (or dropped to no-login), so the
      // normal flow calculates + proceeds instead of dead-ending.
      this.store.dispatch(
        new ManuallyTriggerFinalPriceCheckAddressActions.SetTriggerFinalPriceTimestamp(
          Date.now().toString()
        )
      );
    }
  }

  private async getAuthUserSnapshot(): Promise<any> {
    return new Promise((resolve) => {
      this.store
        .select("auth")
        .pipe(first())
        .subscribe((s: any) =>
          resolve(s && s.user ? _.cloneDeep(s.user) : null)
        )
        .unsubscribe();
    });
  }

  finalPriceManuallyTrigger() {
    // Re-arm the recovery latch whenever the session is consistent; otherwise, if
    // an only_visitor's mode desynced from the order type, reconcile + re-fire
    // (once) before the normal flow so complete-order is never a silent dead-end.
    if (this.isVisitorDeliveryMethodConsistent()) {
      this.visitorModeRecoveryDone = false;
    } else if (
      this.stagePath &&
      this.store_info &&
      this.store_info.store_id &&
      this.currentStoreId &&
      this.store_info.group &&
      this.currentUser &&
      this.currentUser.only_visitor &&
      !this.visitorModeRecoveryInFlight &&
      !this.visitorModeRecoveryDone
    ) {
      this.recoverVisitorModeAndRetry();
      return;
    }

    if (!this.disableFinalPrice) {
      this.store.dispatch(
        new DisableFinalPriceActions.SetDisableFinalPrice(true)
      );
      this.store.dispatch(
        new ManuallyTriggerFinalPriceCheckAddressActions.SetFinalPriceSuccess(
          false
        )
      );
      console.log(
        "all atrr from final price debounce func",
        this.stagePath,
        this.cartProducts,
        this.store_info,
        this.cartCustomerOptions,
        this.activeCoupons,
        this.currentUser
      );
      if (
        this.stagePath &&
        this.store_info &&
        this.store_info.store_id &&
        this.currentStoreId &&
        this.store_info.group &&
        this.isVisitorDeliveryMethodConsistent()
      ) {
        console.log("calling calculateFinalPrice");
        if (this.activeCoupons && this.activeCoupons.length > 0) {
          this.activeCouponsSanityCheck(this.activeCoupons);
        }
        let baseLanguage: string = "";
        const langs = _.cloneDeep(this.groupApp.languages);
        const moBaseLanguage = _.find(langs, { mo_base: true });
        if (moBaseLanguage && moBaseLanguage.code) {
          baseLanguage = moBaseLanguage.code;
        }
        console.log("delivery cost", this.deliveryCost);
        this.calculateFinalPrice(
          {
            store_id: this.store_info.store_id,
            group: this.store_info.group,
            baseLanguage: baseLanguage || "el",
            selectedLanguage: this.selectedLanguage
              ? this.selectedLanguage
              : "el",
            pickup: this.orderPickup,
            dinein: this.dineIn,
            dinein_table_id: this.selectedDineInTable
              ? this.selectedDineInTable.table_id
              : null,
            deliveryCost: this.deliveryCost,
            checkboxPromotions: normalizeCheckboxPromotions(
              this.checkboxPromotions || []
            ),
            cartCustomOptions: _.isArray(this.cartCustomerOptions)
              ? this.cartCustomerOptions
              : [],
            coupons: this.currentUser ? this.activeCoupons : [],
            cart: this.cartProducts || [],
            ...buildPreorderRequestData(
              this.currentUser,
              this.selectedPreorderDate
            ),
            migration_customer_id:
              this.store_info && this.store_info.vatBasedCustomerProductsActive
                ? this.migration_customer_id
                : null,

            selectedPaymentMethodID: this.selectedPaymentMethodID,
            selectedAddress: this.selectedAddress,
            freeDeliveryCostOverAmount: this.freeDeliveryCostOverAmount,
            recommended_products: this.recommended_products || [],
            platform: Capacitor.isNativePlatform() ? "mobile" : "web",
            catalogZeroPricesMode:
              this.currentUser && !this.currentUser.skipCatalogZeroPricesMode
                ? this.currentUser.catalogZeroPricesMode
                : null,
            customer_id: this.currentUser ? this.currentUser.customer_id : null,

            orderCouponRules: this.orderCouponRules,
            onlyDineInUser: this.currentUser?.only_dinein || null,
            uposMoUser: !!this.currentUser?.uposMoUser,
          },
          this.mo_token ? this.mo_token : null
        )
          .pipe(
            catchError((err) => {
              console.log("pipe catch error", err);
              this.store.dispatch(
                new ManuallyTriggerFinalPriceCheckAddressActions.SetFinalPriceSuccess(
                  false
                )
              );
              this.store.dispatch(
                new DisableFinalPriceActions.SetDisableFinalPrice(false)
              );
              return err;
            })
          )
          .subscribe({
            next: async (res: any) => {
              if (res && res.success) {
                this.checkForNotValidCouponsAndPresentAlerts(res);

                if (
                  res.customerPromotions &&
                  !_.isEmpty(res.customerPromotions) &&
                  _.isArray(res.customerPromotions)
                ) {
                  this.store.dispatch(
                    new customerPromotionsActions.SetCustomerPromotions(
                      _.cloneDeep(res.customerPromotions)
                    )
                  );
                } else {
                  this.store.dispatch(
                    new customerPromotionsActions.ClearCustomerPromotions()
                  );
                }

                if (
                  res.checkboxPromotions &&
                  !_.isEmpty(res.checkboxPromotions)
                ) {
                  const mergedCheckboxPromotions =
                    mergeCheckboxPromotionsWithLocalState(
                      res.checkboxPromotions,
                      this.checkboxPromotions
                    );

                  this.store.dispatch(
                    new checkboxPromotionsActions.SetCheckboxPromotions(
                      _.cloneDeep(mergedCheckboxPromotions)
                    )
                  );
                } else {
                  this.store.dispatch(
                    new checkboxPromotionsActions.ClearCheckboxPromotions()
                  );
                  if (navigator.cookieEnabled) {
                    window.localStorage.removeItem("checkboxPromotions");
                  }
                }

                if (res.subTotalNoPromos) {
                  this.store.dispatch(
                    new checkboxPromotionsActions.SetSubtotalNoPromos(
                      _.cloneDeep(res.subTotalNoPromos)
                    )
                  );
                }

                this.store.dispatch(
                  new OrderCouponRulesActions.SetOrderCouponRules(
                    _.cloneDeep(res.orderCouponRules)
                  )
                );

                this.store.dispatch(
                  new AuthActions.SetStoreNetworkConnected(
                    _.cloneDeep(res.storeNetworkConnected) || null
                  )
                );

                if (
                  res.coupons &&
                  !_.isEmpty(res.coupons) &&
                  !this.currentUser?.only_dinein
                ) {
                  this.activeCoupons = res.coupons;
                  this.store.dispatch(
                    new CartActiveCouponsActions.SetActiveCoupons(
                      _.cloneDeep(res.coupons)
                    )
                  );
                } else {
                  this.store.dispatch(
                    new CartActiveCouponsActions.SetActiveCoupons(
                      _.cloneDeep([])
                    )
                  );
                }
                this.cartProducts = res.cart;
                if (res.cart) {
                  this.store.dispatch(
                    new CartActions.SetCartProducts(
                      _.cloneDeep(this.cartProducts)
                    )
                  );
                  if (navigator.cookieEnabled) {
                    window.localStorage.setItem(
                      "cart",
                      JSON.stringify(res.cart)
                    );
                  }
                }
                this.cartProductsGifts = 0;
                _.each(this.cartProducts, (cartProduct) => {
                  if (
                    cartProduct.gift ||
                    cartProduct.product_coupon_timestamp
                  ) {
                    this.cartProductsGifts++;
                  }
                });
                //console.log("giiifts", this.cartProductsGifts);
                if (this.previousCartGifts < this.cartProductsGifts) {
                  let gift = _.find(this.cartProducts, (product) => {
                    if (product.gift || product.product_coupon_timestamp) {
                      this.calculateGiftToShow(gift);
                    }
                  });
                }

                this.previousCartGifts = 0;
                _.each(this.cartProducts, (cartProduct) => {
                  if (cartProduct.gift) {
                    this.previousCartGifts++;
                  }
                });

                this.store
                  .select("deliveryMethodAddress")
                  .pipe(first())
                  .subscribe((state) => {
                    let minOrder;
                    if (state.validStores && state.validStores.length > 0) {
                      let validStores = _.cloneDeep(state.validStores);
                      let currentStore = _.find(validStores, {
                        store_id: this.currentStoreId,
                      });
                      console.log(
                        "valid stores",
                        validStores,
                        this.currentStoreId
                      );
                      console.log("current store", currentStore);
                      if (currentStore) {
                        minOrder = currentStore.minOrder;
                      }

                      console.log("minOrder", minOrder);
                      console.log(
                        "subtotalOfOmittedProductsFromMinOrder",
                        res.subtotalOfOmittedProductsFromMinOrder
                      );
                    }

                    let subtotalOfOmittedProductsFromMinOrder =
                      res.subtotalOfOmittedProductsFromMinOrder;
                    let amountToMinimumOrder: any;

                    //calculate delivery cost
                    let retryFinalPrice = false;
                    if (
                      !state.orderPickup &&
                      !state.dineIn &&
                      parseFloat(subtotalOfOmittedProductsFromMinOrder) > 0
                    ) {
                      let maxDeliveryCharge = 0;

                      _.each(res.cart, (cartProduct) => {
                        if (cartProduct && cartProduct.extra_delivery_charge) {
                          if (
                            maxDeliveryCharge <
                            parseFloat(cartProduct.extra_delivery_charge)
                          ) {
                            maxDeliveryCharge = _.cloneDeep(
                              parseFloat(cartProduct.extra_delivery_charge)
                            );
                          }
                        }
                      });

                      if (
                        res.subtotal ===
                          subtotalOfOmittedProductsFromMinOrder &&
                        res.cart &&
                        res.cart.length > 0 &&
                        maxDeliveryCharge
                      ) {
                        if (
                          parseFloat(this.deliveryCost) !== maxDeliveryCharge
                        ) {
                          retryFinalPrice = true;
                          console.log("retry final price");
                        }

                        if (
                          +parseFloat(this.deliveryCost).toFixed(2) !==
                          maxDeliveryCharge
                        ) {
                          this.deliveryCost = maxDeliveryCharge.toString();
                          this.deliveryCostReplacedWithPrdMaxDeliveryCharge =
                            true;
                          if (
                            this.deliveryCost &&
                            parseFloat(this.deliveryCost)
                          ) {
                            this.deliveryCost = parseFloat(
                              parseFloat(this.deliveryCost).toFixed(1)
                            ).toFixed(2);
                          }
                          console.log(
                            "assign delivery cost",
                            this.deliveryCost
                          );
                        }
                      } else {
                        const oldDeliveryCost = _.cloneDeep(this.deliveryCost);

                        this.calculateDeliveryCost(
                          this.validStores && this.validStores.length
                            ? _.find(_.cloneDeep(this.validStores), {
                                store_id: this.currentStoreId,
                              })
                            : null,
                          _.cloneDeep(this.selectedAddress),
                          res,
                          state.orderPickup,
                          state.dineIn
                        );

                        if (
                          this.oldSentValidStores &&
                          !_.isEqual(this.validStores, this.oldSentValidStores)
                        ) {
                          _.each(this.validStores, (validStore) => {
                            _.each(this.oldSentValidStores, (oldValidStore) => {
                              if (
                                validStore.store_id === oldValidStore.store_id
                              ) {
                              }
                              if (
                                !_.isEqual(
                                  validStore.delivery_cost_per_kilometer_active,
                                  oldValidStore.delivery_cost_per_kilometer_active
                                ) ||
                                !_.isEqual(
                                  validStore.charge_after_distance,
                                  oldValidStore.charge_after_distance
                                ) ||
                                !_.isEqual(
                                  validStore.step_active,
                                  oldValidStore.step_active
                                ) ||
                                !_.isEqual(
                                  validStore.fixed_charge,
                                  oldValidStore.fixed_charge
                                )
                              ) {
                                retryFinalPrice = true;
                              }
                            });
                          });
                        }

                        this.oldSentValidStores = _.cloneDeep(this.validStores);

                        if (oldDeliveryCost !== this.deliveryCost) {
                          console.log(
                            "not equal delivery cost",
                            this.deliveryCost
                          );
                          retryFinalPrice = true;
                        }
                        console.log("deliveryCost", this.deliveryCost);
                      }
                    } else {
                      const oldDeliveryCost = _.cloneDeep(this.deliveryCost);

                      const validStore =
                        this.validStores && this.validStores.length
                          ? _.find(_.cloneDeep(this.validStores), {
                              store_id: this.currentStoreId,
                            })
                          : null;
                      this.calculateDeliveryCost(
                        validStore || null,
                        _.cloneDeep(this.selectedAddress),
                        res,
                        state.orderPickup,
                        state.dineIn
                      );

                      if (
                        this.oldSentValidStores &&
                        !_.isEqual(this.validStores, this.oldSentValidStores)
                      ) {
                        _.each(this.validStores, (validStore) => {
                          _.each(this.oldSentValidStores, (oldValidStore) => {
                            if (
                              validStore.store_id === oldValidStore.store_id
                            ) {
                            }
                            if (
                              !_.isEqual(
                                validStore.delivery_cost_per_kilometer_active,
                                oldValidStore.delivery_cost_per_kilometer_active
                              ) ||
                              !_.isEqual(
                                validStore.charge_after_distance,
                                oldValidStore.charge_after_distance
                              ) ||
                              !_.isEqual(
                                validStore.step_active,
                                oldValidStore.step_active
                              ) ||
                              !_.isEqual(
                                validStore.fixed_charge,
                                oldValidStore.fixed_charge
                              )
                            ) {
                              retryFinalPrice = true;
                            }
                          });
                        });
                      }

                      this.oldSentValidStores = _.cloneDeep(this.validStores);

                      if (oldDeliveryCost !== this.deliveryCost) {
                        console.log(
                          "not equal delivery cost",
                          this.deliveryCost
                        );
                        retryFinalPrice = true;
                      }
                    }

                    if (
                      parseFloat(subtotalOfOmittedProductsFromMinOrder) > 0 &&
                      res.subtotal === subtotalOfOmittedProductsFromMinOrder &&
                      this.deliveryCost &&
                      parseFloat(this.deliveryCost) > 0
                    ) {
                      console.log("Discount is null");
                      amountToMinimumOrder = null;
                    } else if (
                      !state.orderPickup &&
                      !state.dineIn &&
                      !res.ignoreMinOrder &&
                      this.store_info.minorderGrandTotal &&
                      parseFloat(res.grand_total) -
                        parseFloat(
                          res.subtotalOfOmittedCartCustomOptionsFromMinOrder
                        ) -
                        parseFloat(
                          this.deliveryCost ? this.deliveryCost.toString() : "0"
                        ) -
                        parseFloat(res.subtotalOfOmittedProductsFromMinOrder) -
                        parseFloat(minOrder) <
                        parseFloat(minOrder)
                    ) {
                      amountToMinimumOrder =
                        (parseFloat(res.grand_total) -
                          parseFloat(
                            this.deliveryCost
                              ? this.deliveryCost.toString()
                              : "0"
                          ) -
                          parseFloat(
                            res.subtotalOfOmittedCartCustomOptionsFromMinOrder
                          ) -
                          parseFloat(
                            res.subtotalOfOmittedProductsFromMinOrder
                          ) -
                          parseFloat(minOrder)) *
                        -1;
                      amountToMinimumOrder = amountToMinimumOrder.toFixed(2);
                      console.log(
                        "$rootScope.amountToMinimumOrder 1",
                        amountToMinimumOrder
                      );
                      if (
                        amountToMinimumOrder === "0.00" ||
                        parseFloat(amountToMinimumOrder) <= 0
                      ) {
                        amountToMinimumOrder = null;
                      }
                    } else if (
                      !state.orderPickup &&
                      !state.dineIn &&
                      !res.ignoreMinOrder &&
                      !this.store_info.minorderGrandTotal &&
                      parseFloat(res.subtotal) +
                        parseFloat(res.cartCustomOptionsTotalPrice) -
                        parseFloat(
                          res.subtotalOfOmittedCartCustomOptionsFromMinOrder
                        ) -
                        parseFloat(
                          this.deliveryCost ? this.deliveryCost.toString() : "0"
                        ) -
                        parseFloat(res.subtotalOfOmittedProductsFromMinOrder) <
                        parseFloat(minOrder)
                    ) {
                      amountToMinimumOrder =
                        (parseFloat(res.subtotal) +
                          parseFloat(res.cartCustomOptionsTotalPrice) -
                          parseFloat(
                            res.subtotalOfOmittedCartCustomOptionsFromMinOrder
                          ) -
                          parseFloat(
                            res.subtotalOfOmittedProductsFromMinOrder
                          ) -
                          parseFloat(minOrder)) *
                        -1;
                      console.log(
                        "$rootScope.amountToMinimumOrder 2",
                        amountToMinimumOrder
                      );
                      amountToMinimumOrder = amountToMinimumOrder.toFixed(2);
                      if (
                        amountToMinimumOrder === "0.00" ||
                        parseFloat(amountToMinimumOrder) <= 0
                      ) {
                        amountToMinimumOrder = null;
                      }
                    } else {
                      console.log("else discount is to be null");

                      amountToMinimumOrder = null;
                    }
                    // let currentOrderPoints: any;
                    // if (this.groupApp.points && this.groupApp.points.rules) {
                    //   var order_rule = _.find(this.groupApp.points.rules, {
                    //     type: "order",
                    //   });

                    //   if (order_rule) {
                    //     var amount_for_points = parseFloat(
                    //       res.subTotalNoPromos
                    //     );
                    //     console.log("amount_for_points", amount_for_points);
                    //     var points =
                    //       (amount_for_points * order_rule.points_ratio) /
                    //       order_rule.amount_ratio;
                    //     console.log("points", points);
                    //     if (points > 0) {
                    //       currentOrderPoints = points.toFixed();
                    //     } else {
                    //       currentOrderPoints = 0;
                    //     }
                    //   }
                    // } else {
                    //   currentOrderPoints = 0;
                    // }

                    const recommended_products = res.recommended_products;

                    this.calculateRecommendedAppearedProducts(
                      _.cloneDeep(res.cart),
                      recommended_products
                    );
                    this.recommended_products =
                      _.cloneDeep(recommended_products);

                    this.store.dispatch(
                      new RecommendedProductsActions.SetRecommendedProducts(
                        _.cloneDeep(recommended_products || [])
                      )
                    );

                    if (recommended_products && recommended_products.length) {
                      const hasProductsToRecommend = !!_.find(
                        recommended_products,
                        (prd) => {
                          if (prd && !prd.recommendation_appeared) {
                            return prd;
                          }
                        }
                      );

                      if (
                        hasProductsToRecommend &&
                        !this.currentUser?.uposMoUser
                      ) {
                        this.recommendedProductsService.showRecommendedProductsModal();
                      }
                    }

                    let cartPrices = {
                      ...getPartialPaymentPrices(res),
                      subtotal: res.subtotal,
                      deliveryCost:
                        state &&
                        state.orderPickup == false &&
                        state.dineIn == false
                          ? parseFloat(this.deliveryCost)
                          : "",
                      minOrder: minOrder,
                      grand_total_without_delivery_tips:
                        res.grand_total_without_delivery_tips,
                      cartCustomOptionsTotalPriceWithoutTipsAndWrapperTax:
                        res.cartCustomOptionsTotalPriceWithoutTipsAndWrapperTax,
                      deliveryTipsTotal: res.deliveryTipsTotal,
                    waiterTipsTotal: res.waiterTipsTotal,
                      wrapperTaxTotal: res.wrapperTaxTotal,
                      cartCustomOptionsTotalPrice:
                        res.cartCustomOptionsTotalPrice,
                      grand_total: res.grand_total,
                      discount_amount: res.discount_amount,
                      subTotalNoPromos: res.subTotalNoPromos,
                      subtotalOfOmittedCartCustomOptionsFromMinOrder:
                        res.subtotalOfOmittedCartCustomOptionsFromMinOrder,
                      subtotalOfOmittedProductsFromMinOrder:
                        res.subtotalOfOmittedProductsFromMinOrder,
                      amountToMinimumOrder: amountToMinimumOrder,
                      currentOrderPoints: res.points,
                      points_deducted_from_coupon:
                        res.points_deducted_from_coupon,
                      vatLevelsTotals: res.vatLevelsTotals,
                      vat_total: res.vat_total,
                      deliveryCostReplacedWithPrdMaxDeliveryCharge:
                        this.deliveryCostReplacedWithPrdMaxDeliveryCharge,
                    };
                    this.store.dispatch(
                      new CartPricesActions.SetCartPrices(
                        _.cloneDeep(cartPrices)
                      )
                    );
                    this.dispathcingFromFinalPrice = false;
                    if (retryFinalPrice) {
                      retryFinalPrice = false;
                      this.store.dispatch(
                        new DisableFinalPriceActions.SetTriggerFinalPriceTimestamp(
                          Date.now()
                        )
                      );
                    }
                    this.store.dispatch(
                      new DisableFinalPriceActions.SetDisableFinalPrice(false)
                    );
                  })
                  .unsubscribe();

                if (
                  res.groupAppUpdatedAttributes &&
                  _.isObject(res.groupAppUpdatedAttributes) &&
                  !_.isEmpty(res.groupAppUpdatedAttributes)
                ) {
                  this.updateGroupAppAttr(res.groupAppUpdatedAttributes);
                }

                if (
                  res.storeUpdatedAttributes &&
                  _.isObject(res.storeUpdatedAttributes) &&
                  !_.isEmpty(res.storeUpdatedAttributes)
                ) {
                  await this.updateStoreInfoAttr(res.storeUpdatedAttributes);
                }

                this.store.dispatch(
                  new ManuallyTriggerFinalPriceCheckAddressActions.SetFinalPriceSuccess(
                    true
                  )
                );
                this.analyticsService.dmAnalyticsMessage(
                  "cart_calculation",
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null
                );
              } else {
                //TO_DO_NOW ERROR MESSAGE
                this.clearPartialPaymentPrices();
                if (await this.handleVisitorInvalidError(res)) {
                  return;
                }
                const alert = await this.alertController.create({
                  header: this.translateService.instant("alert"),
                  message:
                    res && res.comment_id
                      ? this.translateService.instant(res.comment_id)
                      : this.translateService.instant(
                          "errorMessages.general_error"
                        ),
                  backdropDismiss: false,
                  buttons: ["OK"],
                });
                await alert.present();
                this.store.dispatch(
                  new ManuallyTriggerFinalPriceCheckAddressActions.SetFinalPriceSuccess(
                    false
                  )
                );
                this.store.dispatch(
                  new DisableFinalPriceActions.SetDisableFinalPrice(false)
                );
              }
            },
            error: async (error) => {
              console.log(" catch error", error);
              this.clearPartialPaymentPrices();

              this.store.dispatch(
                new ManuallyTriggerFinalPriceCheckAddressActions.SetFinalPriceSuccess(
                  false
                )
              );
              this.store.dispatch(
                new DisableFinalPriceActions.SetDisableFinalPrice(false)
              );

              if (
                error &&
                error.status !== 401 &&
                error.statusText !== "Unauthorized"
              ) {
                const alert = await this.alertController.create({
                  header: this.translateService.instant("alert"),
                  message: this.translateService.instant(
                    "errorMessages.problem_reaching_server"
                  ),

                  buttons: ["OK"],
                });
                await alert.present();
              }

              return error;
            },
          });
      } else {
        this.store.dispatch(
          new ManuallyTriggerFinalPriceCheckAddressActions.SetFinalPriceSuccess(
            false
          )
        );
        this.store.dispatch(
          new DisableFinalPriceActions.SetDisableFinalPrice(false)
        );
        // this.calculateFinalPriceDebounce();
      }
    } else {
      console.log("finalPrice is disabled");
    }
    console.log("debounced function");
  }

  updateGroupAppAttr(attributesUpdateObject) {
    if (this.groupApp && attributesUpdateObject) {
      const newGroupApp = _.assign(
        _.cloneDeep(this.groupApp),
        attributesUpdateObject
      );

      this.store.dispatch(new groupAppActions.SetGroupApp(newGroupApp));
    }
  }

  async updateStoreInfoAttr(attributesUpdateObject) {
    if (this.store_info && attributesUpdateObject) {
      const oldStoreInfo = _.cloneDeep(this.store_info);

      const newStoreInfo = _.assign(
        _.cloneDeep(this.store_info),
        attributesUpdateObject
      );

      const store_index = _.findIndex(this.stores, {
        store_id: newStoreInfo.store_id,
      });

      if (store_index !== -1) {
        const updatedStores = _.cloneDeep(this.stores);
        updatedStores[store_index] = newStoreInfo;
        this.store.dispatch(new storesActions.SetStores(updatedStores));

        await this.handleExpressDeliveryOptionChange(
          oldStoreInfo,
          newStoreInfo
        );
      }
    }
  }

  private getExpressDeliveryOption(storeInfo: any) {
    if (
      storeInfo &&
      storeInfo.cartCustomOptions &&
      storeInfo.cartCustomOptions.length
    ) {
      return _.find(storeInfo.cartCustomOptions, {
        preNameId: "express_delivery",
      });
    }
    return null;
  }

  private async handleExpressDeliveryOptionChange(
    oldStoreInfo: any,
    newStoreInfo: any
  ) {
    const oldExpressOption = this.getExpressDeliveryOption(oldStoreInfo);
    const newExpressOption = this.getExpressDeliveryOption(newStoreInfo);

    if (
      !oldExpressOption ||
      !newExpressOption ||
      !oldExpressOption.choices ||
      !newExpressOption.choices ||
      !oldExpressOption.choices.length ||
      !newExpressOption.choices.length
    ) {
      return;
    }

    const oldChoice = oldExpressOption.choices[0];
    const newChoice = newExpressOption.choices[0];

    if (!oldChoice || !newChoice) {
      return;
    }

    const oldTitle = oldChoice.title;
    const newTitle = newChoice.title;

    const oldPrice =
      typeof oldChoice.price !== "undefined" && oldChoice.price !== null
        ? parseFloat(oldChoice.price)
        : null;
    const newPrice =
      typeof newChoice.price !== "undefined" && newChoice.price !== null
        ? parseFloat(newChoice.price)
        : null;

    const titleChanged = oldTitle !== newTitle;
    const priceChanged = oldPrice !== newPrice;

    if (!titleChanged && !priceChanged) {
      return;
    }

    this.store
      .select("cartCustomOptionsSelections")
      .pipe(first())
      .subscribe(async (selectionsState) => {
        const selections =
          selectionsState &&
          selectionsState.cartCustomOptionsSelections &&
          selectionsState.cartCustomOptionsSelections.length
            ? _.cloneDeep(selectionsState.cartCustomOptionsSelections)
            : null;

        const selectionExpress = selections
          ? _.find(selections, { preNameId: "express_delivery" })
          : null;

        const selectedChoice =
          selectionExpress &&
          selectionExpress.choices &&
          selectionExpress.choices.length
            ? selectionExpress.choices[0]
            : null;

        const isSelected =
          !!selectedChoice &&
          ((typeof selectedChoice.selected !== "undefined" &&
            selectedChoice.selected) ||
            (typeof selectedChoice.qty !== "undefined" &&
              selectedChoice.qty > 0));

        // Always update selections with the latest option data so UI reflects changes
        const optionClone = _.cloneDeep(newExpressOption);
        if (
          selectionExpress &&
          selectionExpress.choices &&
          selectionExpress.choices.length &&
          optionClone.choices &&
          optionClone.choices.length
        ) {
          _.each(optionClone.choices, (choice) => {
            const existingChoice = _.find(selectionExpress.choices, {
              timestamp: choice.timestamp,
            });
            if (existingChoice) {
              if (
                typeof existingChoice.selected !== "undefined" &&
                existingChoice.selected !== null
              ) {
                choice.selected = existingChoice.selected;
              }
              if (
                typeof existingChoice.qty !== "undefined" &&
                existingChoice.qty !== null
              ) {
                choice.qty = existingChoice.qty;
              }
              if (existingChoice.text) {
                choice.text = existingChoice.text;
              }
            }
          });
        }

        this.store.dispatch(
          new CartCustomOptionsSelectionsActions.AddUpdateCartCustomOptionSelections(
            optionClone
          )
        );

        // If not selected, just update UI (no alert)
        if (!isSelected) {
          return;
        }

        let translationKey: string;
        let translationParams: any = {};

        if (titleChanged) {
          translationKey =
            "cartCustomOptions.express_delivery_title_changed_message";
          translationParams = { newTitle };
        } else if (priceChanged) {
          translationKey =
            "cartCustomOptions.express_delivery_price_changed_message";
          translationParams = {
            newPrice:
              newPrice !== null && newPrice !== undefined
                ? newPrice.toFixed(2)
                : "",
          };
        } else {
          return;
        }

        const alert = await this.alertController.create({
          header: this.translateService.instant("alert"),
          message: this.translateService.instant(
            translationKey,
            translationParams
          ),
          cssClass: "express-delivery-alert",
          buttons: [
            {
              text: this.translateService.instant(
                "cartCustomOptions.express_delivery_deselect"
              ),
              handler: () => {
                this.deselectExpressDeliveryOption(newExpressOption);
              },
            },

            {
              text: this.translateService.instant(
                "cartCustomOptions.express_delivery_keep_selected"
              ),
              role: "cancel",
            },
          ],
        });

        setTimeout(async () => {
          await alert.present();
        }, 0);
      })
      .unsubscribe();
  }

  private deselectExpressDeliveryOption(expressOption: any) {
    if (
      !expressOption ||
      !expressOption.choices ||
      !expressOption.choices.length
    ) {
      return;
    }

    const optionClone = _.cloneDeep(expressOption);

    _.each(optionClone.choices, (choice, index: any) => {
      if (index === 0) {
        choice.selected = false;
        choice.qty = 0;
      }
    });

    this.store.dispatch(
      new CartCustomOptionsSelectionsActions.AddUpdateCartCustomOptionSelections(
        optionClone
      )
    );

    this.store
      .select("cartCustomerOptions")
      .pipe(first())
      .subscribe((state) => {
        if (
          state &&
          state.cartCustomerOptions &&
          state.cartCustomerOptions.length
        ) {
          const updatedCartCustomerOptions = _.filter(
            _.cloneDeep(state.cartCustomerOptions),
            (option) => option.preNameId !== "express_delivery"
          );

          this.store.dispatch(
            new CartCustomerOptionsActions.SetCartCustomerOptions(
              updatedCartCustomerOptions
            )
          );
        }
      })
      .unsubscribe();
  }

  private clearPartialPaymentPrices() {
    this.store
      .select("cartPrices")
      .pipe(first())
      .subscribe((state) => {
        if (state?.cartPrices && _.has(state.cartPrices, "partial_payment")) {
          this.store.dispatch(
            new CartPricesActions.SetCartPrices(
              _.omit(state.cartPrices, [
                "partial_payment",
                "partial_payment_contract_version",
                "partial_payment_coupon_amount",
                "partial_payment_coupon_applied_amount",
              ])
            )
          );
        }
      });
  }

  checkForNotValidCouponsAndPresentAlerts(response) {
    if (this.activeCoupons && this.activeCoupons.length) {
      const foundProductWithoutPromo = _.find(this.cartProducts, (product) => {
        if (!product.promo) {
          return product;
        }
      });

      if (
        _.find(this.activeCoupons, { couponCheckbox: true }) &&
        !_.find(response.coupons, { couponCheckbox: true }) &&
        !foundProductWithoutPromo &&
        response.cart &&
        response.cart.length > 0
      ) {
        console.log("with this promo cart you cant use a coupon");
        this.store.dispatch(
          new CartActions.SetPromoCartNoCouponTimestamp(Date.now().toString())
        );
      } else if (
        _.find(this.activeCoupons, {
          couponCheckbox: true,
          preorder_only: true,
          validDate: true,
        }) &&
        !_.find(response.coupons, { couponCheckbox: true }) &&
        (!this.selectedPreorderDate ||
          !this.selectedPreorderDate.date ||
          !this.selectedPreorderDate.hour)
      ) {
        console.log(
          "you dont selected preorder so you cant use preorder only coupons"
        );

        const selectedCoupon = _.find(this.activeCoupons, {
          couponCheckbox: true,
        });

        const responseSelectedCoupon = _.find(response.coupons, {
          timestamp: selectedCoupon.timestamp,
        });

        if (responseSelectedCoupon.validDate) {
          this.store.dispatch(
            new CartActions.setPreorderOnlyNoCouponTimestamp(
              Date.now().toString()
            )
          );
        }
      } else if (
        _.find(this.activeCoupons, {
          couponCheckbox: true,
          online_payment_only: true,
          validDate: true,
        }) &&
        !_.find(response.coupons, { couponCheckbox: true })
      ) {
        console.log(
          "Coupon is only for online payment cant use cash or Mobile POS"
        );

        const selectedCoupon = _.find(this.activeCoupons, {
          couponCheckbox: true,
        });

        const responseSelectedCoupon = _.find(response.coupons, {
          timestamp: selectedCoupon.timestamp,
        });

        if (responseSelectedCoupon.validDate) {
          this.store.dispatch(
            new CartActions.setOnlinePaymentOnlyNoCouponTimestamp(
              Date.now().toString()
            )
          );
        }
      } else if (
        _.find(this.activeCoupons, {
          couponCheckbox: true,
        }) &&
        !_.find(response.coupons, { couponCheckbox: true })
      ) {
        //TODO check all the cases for delivery_only etc

        const coupon = _.find(this.activeCoupons, {
          couponCheckbox: true,
        });
        const deliveryMethod = this.calculateDeliveryMethod(
          this.orderPickup,
          this.dineIn
        );
        const responseCoupon = _.find(response.coupons, {
          timestamp: coupon.timestamp,
        });

        let errorMsg;

        if (coupon.only_mobile_apps && !Capacitor.isNativePlatform()) {
          errorMsg = this.translateService.instant(
            "cart.cart-components.cart-active-coupons.you-must-download-the-app-to-use-the-coupon"
          );
        } else if (
          coupon &&
          coupon.appliesToCategoriesOrProducts &&
          coupon.appliesToCategoriesOrProducts.length &&
          !_.some(this.cartProducts || [], (prd) =>
            _.some(
              coupon.appliesToCategoriesOrProducts,
              (item) =>
                item &&
                (item.type === "category" ||
                  (!item.product_id && !item.sku && !item.product)) &&
                item.id === prd.category_id
            )
          )
        ) {
          const categoryNames = _.chain(coupon.appliesToCategoriesOrProducts)
            .filter(
              (item) =>
                item &&
                item.name &&
                (item.type === "category" ||
                  (!item.product_id && !item.sku && !item.product))
            )
            .map("name")
            .compact()
            .uniq()
            .value();

          if (categoryNames && categoryNames.length) {
            errorMsg =
              this.translateService.instant(
                "cart.cart-components.cart-active-coupons.the-coupon-is-only-valid-for-categories"
              ) +
              ": " +
              categoryNames.join(", ");
          }
        } else if (
          coupon.delivery_only &&
          coupon.dinein_only &&
          deliveryMethod !== "delivery" &&
          deliveryMethod !== "dinein"
        ) {
          errorMsg = this.translateService.instant(
            "cart.cart-components.cart-active-coupons.the-coupon-is-for-only-delivery-and-dine-in"
          );
        } else if (
          coupon.delivery_only &&
          coupon.takeaway_only &&
          deliveryMethod !== "delivery" &&
          deliveryMethod !== "takeaway"
        ) {
          errorMsg = this.translateService.instant(
            "cart.cart-components.cart-active-coupons.the-coupon-is-for-only-delivery-and-takeaway"
          );
        } else if (
          coupon.dinein_only &&
          coupon.takeaway_only &&
          deliveryMethod !== "dinein" &&
          deliveryMethod !== "takeaway"
        ) {
          errorMsg = this.translateService.instant(
            "cart.cart-components.cart-active-coupons.the-coupon-is-for-only-dine-in-and-takeaway"
          );
        } else if (coupon.delivery_only && deliveryMethod !== "delivery") {
          errorMsg = this.translateService.instant(
            "cart.cart-components.cart-active-coupons.the-coupon-is-for-only-delivery"
          );
        } else if (coupon.dinein_only && deliveryMethod !== "dinein") {
          errorMsg = this.translateService.instant(
            "cart.cart-components.cart-active-coupons.the-coupon-is-for-only-dine-in"
          );
        } else if (coupon.takeaway_only && deliveryMethod !== "takeaway") {
          errorMsg = this.translateService.instant(
            "cart.cart-components.cart-active-coupons.the-coupon-is-for-only-takeaway"
          );
        } else if (
          responseCoupon &&
          responseCoupon.validDate &&
          responseCoupon.validMinOrder === false &&
          hasCouponMinOrderRules(responseCoupon)
        ) {
          // Per-mode minimum or "discount_items" basis: the server unticked the
          // coupon because the minimum of the current order mode (or of the
          // discounted products) is not reached. Legacy coupons stay silent.
          errorMsg = buildCouponMinOrderErrorMessage(
            responseCoupon,
            deliveryMethod,
            (key) => this.translateService.instant(key)
          );
        }

        // Show the error message if one is set
        if (errorMsg) {
          this.presentErrorToast(errorMsg, "danger");
        }
      }
    }
  }

  async presentErrorToast(message, color) {
    if (this.toastError) {
      // console.log("toast exist");
      try {
        console.log(this.toastError);
        this.toastError.dismiss();
        this.toastError = null;
      } catch (e) {}
    }
    this.toastError = await this.toastController.create({
      message: message,
      duration: 6000,
      position: "middle",

      color: color,
      buttons: [
        {
          side: "end",
          icon: "assets/ionicons/close.svg",

          handler: () => {
            console.log("Toast Closed");
          },
        },
      ],
    });

    this.toastError.present();
  }

  showProductDetailsModalForGift(product, cart_id) {
    const detailsCssClass =
      this.productDetailsOperationsService.getProductDetailsModalCssClass(
        _.cloneDeep(product),
        _.cloneDeep({
          height: window.innerHeight,
          width: window.innerWidth,
        })
      );
    if (!this.productDetailsModal) {
      this.productDetailsModal = true;
      this.presentProductDetailsModal(product, cart_id, detailsCssClass, true);
    }
  }

  async presentProductDetailsModal(product, cart_id, detailsCssClass, gift) {
    this.productDetailsModal = await this.modalCtrl.create({
      component: ProductDetailsComponent,
      cssClass: detailsCssClass,
      animated: true,
      componentProps: {
        product_id: product.product_id,
        cart_id: cart_id,
        giftFromCalculateFinalPrice: !!gift,
        product_coupon_timestamp: product.product_coupon_timestamp || null,
        gift_product_coupon_timestamp:
          product.gift_product_coupon_timestamp || null,
      },
      backdropDismiss: false,
    });

    await this.productDetailsModal.present();
    this.productDetailsModal.onDidDismiss().then(() => {
      this.productDetailsModal = null;
    });
  }

  public closeProductDetailsModal() {
    if (this.productDetailsModal) {
      this.productDetailsModal.dismiss();
      this.productDetailsModal = null;
    }
  }
  private calculateFinalPrice(data, mo_token) {
    const bundleQuoteContext = this.bundleOfferSuggestionService?.captureQuoteContext();
    if (mo_token) {
      return this.http
        .post(
          "https://api.deliverymanager.gr/" +
            this.stagePath +
            "/calculateFinalPriceForCustomer",
          JSON.stringify(data),
          {
            headers: new HttpHeaders({
              "Content-Type": "application/json; charset=utf-8",
              Authorization: mo_token,
            }),
          }
        )
        .pipe(timeout(20000))
        .pipe(retry(2), map(response => this.bundleOfferSuggestionService?.filterPricingResponse(response, bundleQuoteContext) || response));
    } else {
      return this.http
        .post(
          "https://api.deliverymanager.gr/" +
            this.stagePath +
            "/calculateFinalPrice",
          JSON.stringify(data),
          {
            headers: new HttpHeaders({
              "Content-Type": "application/json; charset=utf-8",
            }),
          }
        )
        .pipe(timeout(20000))
        .pipe(retry(2), map(response => this.bundleOfferSuggestionService?.filterPricingResponse(response, bundleQuoteContext) || response));
    }
  }

  calculateDeliveryCostByKmCases(
    charge_after_distance,
    step_active,
    step_distance,
    fixed_charge,
    distance_by_store_id,
    currentValidStore
  ) {
    const getDeliveryCost = (multiplier, fixedCharge) => {
      let deliveryCost: any = currentValidStore.deliveryCost
        ? parseFloat(
            currentValidStore.deliveryCost.toString().replace(",", ".")
          )
        : 0;

      deliveryCost = (deliveryCost * multiplier + (fixedCharge || 0)).toFixed(
        2
      );

      if (deliveryCost && parseFloat(deliveryCost.toString())) {
        deliveryCost = parseFloat(
          parseFloat(deliveryCost.toString()).toFixed(1)
        ).toFixed(2);
      }

      return deliveryCost;
    };

    const calculateDistanceToCharge = () => {
      let distanceToCharge = distance_by_store_id * 1000;
      if (charge_after_distance) {
        distanceToCharge -= charge_after_distance;
        if (distanceToCharge < 0) {
          distanceToCharge = 0;
        }
      }
      return distanceToCharge || 0;
    };

    const distanceToCharge = calculateDistanceToCharge();

    if (step_active && step_distance) {
      const numberOfSteps = Math.floor(distanceToCharge / step_distance);
      if (numberOfSteps >= 0) {
        this.deliveryCost = getDeliveryCost(numberOfSteps, fixed_charge);
        console.log("assign delivery cost", this.deliveryCost);
      } else {
        console.log("ERROR: cant find distance by store id attr");
      }
    } else {
      const distanceInKm = charge_after_distance
        ? parseFloat((distanceToCharge / 1000).toFixed(2))
        : distance_by_store_id;
      if (distanceInKm >= 0) {
        this.deliveryCost = getDeliveryCost(distanceInKm, fixed_charge);
        console.log("assign delivery cost", this.deliveryCost);
      } else {
        console.log("ERROR: cant find distance by store id attr");
      }
    }
  }

  private calculateDeliveryCost(
    currentValidStore,
    selectedAddress,
    calculateResponse,
    orderPickup,
    dineIn
  ) {
    this.deliveryCostReplacedWithPrdMaxDeliveryCharge = false;

    const shouldSkipDeliveryCost = _.find(
      calculateResponse?.cart || this.cartProducts || [],
      (cartProduct) => cartProduct && cartProduct.orderSkipDeliveryCost === true
    );

    if (shouldSkipDeliveryCost) {
      this.deliveryCost = "0";
      this.freeDeliveryCostOverAmount = false;
      return;
    }

    if (!(orderPickup === false && dineIn === false)) {
      this.deliveryCost = "0";
    } else {
      if (
        currentValidStore &&
        currentValidStore.delivery_cost_per_kilometer_active
      ) {
        let distance_by_store_id;
        if (
          currentValidStore.calculation_type &&
          currentValidStore.calculation_type === "radius"
        ) {
          distance_by_store_id =
            selectedAddress &&
            selectedAddress.radius_distance_by_store_id &&
            (selectedAddress.radius_distance_by_store_id[
              currentValidStore.store_id
            ] ||
              selectedAddress.radius_distance_by_store_id[
                currentValidStore.store_id
              ] === 0)
              ? selectedAddress.radius_distance_by_store_id[
                  currentValidStore.store_id
                ]
              : null;

          if (!distance_by_store_id) {
            distance_by_store_id =
              selectedAddress &&
              selectedAddress.distance_by_store_id &&
              selectedAddress.distance_by_store_id[
                currentValidStore.store_id
              ] &&
              (selectedAddress.distance_by_store_id[currentValidStore.store_id]
                .distance ||
                selectedAddress.distance_by_store_id[currentValidStore.store_id]
                  .distance === 0) &&
              selectedAddress.distance_by_store_id[currentValidStore.store_id]
                .estimated
                ? selectedAddress.distance_by_store_id[
                    currentValidStore.store_id
                  ].distance
                : null;
          }
        } else {
          distance_by_store_id =
            selectedAddress &&
            selectedAddress.distance_by_store_id &&
            selectedAddress.distance_by_store_id[currentValidStore.store_id] &&
            (selectedAddress.distance_by_store_id[currentValidStore.store_id]
              .distance ||
              selectedAddress.distance_by_store_id[currentValidStore.store_id]
                .distance === 0)
              ? selectedAddress.distance_by_store_id[currentValidStore.store_id]
                  .distance
              : null;
        }

        console.log("distance_by_store_id", distance_by_store_id);

        const stepRoundUp = (num, param) => {
          if (param <= 0) {
            throw new Error("Parameter must be a positive number");
          }
          return Math.ceil(num / param) * param;
        };

        if (currentValidStore.distance_charge_type === "levels") {
          if (
            currentValidStore.step_active &&
            currentValidStore.step_distance
          ) {
            distance_by_store_id = stepRoundUp(
              parseFloat(
                parseFloat((distance_by_store_id * 1000).toString()).toFixed(2)
              ),
              currentValidStore.step_distance
            );
          } else {
            distance_by_store_id = stepRoundUp(
              parseFloat(
                parseFloat((distance_by_store_id * 1000).toString()).toFixed(2)
              ),
              1000
            );
          }

          distance_by_store_id = parseFloat(
            parseFloat(
              (parseFloat(distance_by_store_id) / 1000).toString()
            ).toFixed(2)
          );
        }

        this.calculateDeliveryCostByKmCases(
          currentValidStore.charge_after_distance,
          currentValidStore.step_active,
          currentValidStore.step_distance,
          currentValidStore.fixed_charge,
          distance_by_store_id,
          currentValidStore
        );
      } else {
        if (currentValidStore) {
          this.deliveryCost = currentValidStore.deliveryCost
            ? currentValidStore.deliveryCost.toString().replace(",", ".")
            : 0;

          if (this.deliveryCost && parseFloat(this.deliveryCost)) {
            this.deliveryCost = parseFloat(
              parseFloat(this.deliveryCost).toFixed(1)
            ).toFixed(2);
          }
        }
      }
    }
    if (calculateResponse && !_.isEmpty(calculateResponse)) {
      this.checkFreeDeliveryOverAmount(
        currentValidStore,
        calculateResponse.grand_total,
        calculateResponse.subtotal,
        calculateResponse.cartCustomOptionsTotalPrice,
        calculateResponse.subtotalOfOmittedCartCustomOptionsFromMinOrder,
        calculateResponse.subtotalOfOmittedProductsFromMinOrder,
        calculateResponse.freeDeliveryCostOverAmount
      );
    }
  }

  private checkFreeDeliveryOverAmount(
    currentValidStore,
    grand_total,
    subtotal,
    cartCustomOptionsTotalPrice,
    subtotalOfOmittedCartCustomOptionsFromMinOrder,
    subtotalOfOmittedProductsFromMinOrder,
    freeDeliveryCostOverAmount
  ) {
    console.log(
      "checkFreeDeliveryOverAmount",
      currentValidStore,
      grand_total,
      subtotal,
      cartCustomOptionsTotalPrice,
      subtotalOfOmittedCartCustomOptionsFromMinOrder,
      subtotalOfOmittedProductsFromMinOrder,
      this.deliveryCost
    );
    if (
      currentValidStore &&
      currentValidStore.free_delivery_over_amount > 0 &&
      this.deliveryCost &&
      this.deliveryCost !== "0"
    ) {
      if (this.store_info.minorderGrandTotal) {
        if (
          parseFloat(grand_total.toString()) -
            (freeDeliveryCostOverAmount
              ? 0
              : parseFloat(
                  this.deliveryCost ? this.deliveryCost.toString() : "0"
                )) -
            parseFloat(subtotalOfOmittedCartCustomOptionsFromMinOrder) -
            parseFloat(subtotalOfOmittedProductsFromMinOrder) >
          parseFloat(currentValidStore.free_delivery_over_amount.toString())
        ) {
          console.log("ZERO DELIVERY COST");
          this.deliveryCost = "0";

          this.freeDeliveryCostOverAmount = true;
          return true;
        } else {
          this.freeDeliveryCostOverAmount = false;
        }
      } else {
        if (
          parseFloat(subtotal) +
            parseFloat(cartCustomOptionsTotalPrice) -
            parseFloat(subtotalOfOmittedCartCustomOptionsFromMinOrder) -
            parseFloat(subtotalOfOmittedProductsFromMinOrder) >
          parseFloat(currentValidStore.free_delivery_over_amount.toString())
        ) {
          console.log("ZERO DELIVERY COST");
          this.deliveryCost = "0";

          this.freeDeliveryCostOverAmount = true;

          return true;
        } else {
          this.freeDeliveryCostOverAmount = false;
        }
      }
    }
    return false;
  }

  private activeCouponsSanityCheck(activeCoupons) {
    let found;
    _.each(activeCoupons, (coupon) => {
      if (coupon.couponCheckbox && !found) {
        found = true;
        return;
      }
      if (coupon.couponCheckbox && found) {
        coupon.couponCheckbox = false;
      }
    });
    console.log("active coupons sanitycheck", activeCoupons);
  }

  private calculateGiftToShow(gift) {
    if (
      gift &&
      gift.options &&
      gift.options.length &&
      gift.options.length > 1
    ) {
      if (this.groupApp && this.groupApp.active_reservation_app) {
        if (
          this.router &&
          this.router.url &&
          this.router.url.indexOf("catalog") === -1 &&
          this.router.url.indexOf("cart") === -1
        ) {
          this.reservationSystemModalsService.closeReservationCouponsSelectionModal();

          this.router
            .navigateByUrl("reservationSystem/reservation-catalog", {
              replaceUrl: true,
            })
            .then(() => {
              setTimeout(() => {
                this.showProductDetailsModalForGift(gift, gift.cart_id);
              }, 1500);
            });
        } else {
          this.showProductDetailsModalForGift(gift, gift.cart_id);
        }
      } else {
        this.showProductDetailsModalForGift(gift, gift.cart_id);
      }
    } else {
      if (
        this.groupApp &&
        this.groupApp.active_reservation_app &&
        this.router &&
        this.router.url &&
        this.router.url.indexOf("catalog") === -1 &&
        this.router.url.indexOf("cart") === -1
      ) {
        this.reservationSystemModalsService.closeReservationCouponsSelectionModal();
        this.router.navigateByUrl("reservationSystem/reservation-catalog", {
          replaceUrl: true,
        });
      }
    }
  }

  private calculateRecommendedAppearedProduct(
    cartProduct,
    recommended_products
  ) {
    _.each(cartProduct.options, (option) => {
      _.each(option.choices, (choice) => {
        if (choice.bundle === true && !_.isEmpty(choice.bundled_product)) {
          this.calculateRecommendedAppearedProduct(
            choice.bundled_product,
            recommended_products
          );
        }
      });
    });

    _.each(recommended_products, (rec_prd, index) => {
      if (
        rec_prd.product_id === cartProduct.product_id ||
        rec_prd.category_id === cartProduct.category_id
      ) {
        recommended_products[index].recommendation_appeared = true;
      }
    });
  }

  private calculateRecommendedAppearedProducts(
    cartProducts,
    recommended_products
  ) {
    _.each(cartProducts, (cartPrd) => {
      this.calculateRecommendedAppearedProduct(cartPrd, recommended_products);
    });
  }
}
